<template>
  <div class="handle">
    <div class="handle_action">
      <div class="handle_action_item" @click="switchCollapse">
        <template v-if="adminCollapse">
          <i class="icon el-icon-rank"></i>
        </template>
        <template v-else>
          <i class="icon el-icon-full-screen"></i>
        </template>
      </div>
      <el-badge :is-dot="false" class="handle_action_item">
        <i class="icon el-icon-chat-dot-round" @click="redirectLetter"></i>
      </el-badge>
      <el-badge :is-dot="false" class="handle_action_item">
        <i class="icon el-icon-bell"></i>
      </el-badge>
      <div class="handle_action_item">
        <i class="icon el-icon-house" @click="redirectIndex"></i>
      </div>
    </div>
    <div class="handle_leave" @click="adminLeave">
      <span class="label">退出</span>
      <i class="icon el-icon-switch-button"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    adminCollapse: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    redirectLetter() {
      this.$router.push({ path: "/letter/index" }).catch(() => {});
    },
    redirectIndex() {
      this.$router.push({ path: "/admin/index" }).catch(() => {});
    },
    switchCollapse() {
      let payload = { adminCollapse: !this.adminCollapse };
      this.$store.commit("SET_ASIDECOLLAPSE", payload);
    },
    adminLeave() {
      this.$confirm("此操作将注销当前用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let result = await this.$store.dispatch("adminLeave", {});
          if (result == "success") {
            this.$router.push({ path: "/admin/login" }).catch(() => {});
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./header.scss");
</style>
